import * as React from 'react';
import { PrismicRichText } from '@prismicio/react';
import { Box } from '../../../design-system';
import { CmsText } from '../types';
import { useMediaQueries } from '../../common/hooks/useMediaQuery';
import { hasValidCmsText } from '../../home/utils';

type Props = {
  body: CmsText;
  column: string;
  withImage?: boolean;
};

const BrandText = ({ body, column, withImage }: Props) => {
  const { isDesktop, isTablet, isMobile } = useMediaQueries();

  const px = withImage
    ? 'l'
    : !isDesktop
      ? 'm'
      : column === 'full'
        ? 'h'
        : column === 'half'
          ? 'xxxl'
          : 'l';
  const pt = withImage ? 'm' : 'na';

  return (
    <Box textAlign="center" px={px} pt={pt}>
      {isDesktop && !withImage && hasValidCmsText(body) && (
        <Box width="800px">
          <PrismicRichText field={body} />
        </Box>
      )}
      {isTablet && !withImage && hasValidCmsText(body) && (
        <Box width="600px">
          <PrismicRichText field={body} />
        </Box>
      )}
      {(withImage || (isMobile && !withImage)) && hasValidCmsText(body) && (
        <PrismicRichText field={body} />
      )}
    </Box>
  );
};

export default BrandText;
